<template>
    <div>
        <Tables ref="tableDocuments"
            :columns="headTable"
            :showSearch="false"
            :showPrint="false"
            :showDownload="false"
            :showFullscreen="false"
            v-on:Load="onLoad"
        >
            <tr v-for="document in documentsArray" :key="document.id">
                <TableColumn :IsText="true"    :status="1" :value="document.nome" />
                <TableColumn :IsText="true"    :status="1" :value="document.destino" />
                <TableColumn :IsText="true"    :status="1" :value="document.dataAcaoFormatada" />
                <TableColumn :IsDocumentActions="true" :HasDownload="true" v-on:Download="onDownloadDocument(document.id)" :status="1"  />
            </tr>
        </Tables>
    </div>
</template>

<script>
import TableDocuments from './TableDocuments.js'
export default TableDocuments
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/private/documentsManagement/components/TableDocuments/TableDocuments.vue